import { Theme, styled } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  message?: string;
  withSkeleton?: boolean;
};

const StyledLoadingMessage = styled('div')<Theme>(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  fontFamily: theme.config.primaryFontFamily,
  fontSize: '3rem',
  fontWeight: 400,
  color: theme.palette.grey['500'],
}));

const Loading: FC<Props> = ({ message, withSkeleton = false }) => {
  const { t } = useTranslation();
  const label = message || t('shared.loading');
  if (!withSkeleton) return <StyledLoadingMessage>{label}</StyledLoadingMessage>;
  return (
    <>
      <Skeleton variant="rect" height="100%"></Skeleton>
      <StyledLoadingMessage>{label}</StyledLoadingMessage>;
    </>
  );
};

export default Loading;
